import React from 'react';

import styled from '@emotion/styled';

import LogoHeader from '../../components/LogoHeader/LogoHeader';
import { Modal } from '../../components/Modal/Modal';
import { ModalProvider } from '../../Context/ModalContext';
import usePackageInfo from '../../hooks/TrackPackage/PackageInfo';
import { getPackageStatus } from '../../utils/utils';
import PackageStatusGraph from './PackageStatusGraph';
import ReportIssueBtn from './ReportIssueBtn';
import ReportIssueModal from './ReportIssueModal';

const TrackPackage = () => {
  const { packageInfo } = usePackageInfo();
  console.log('packageInfo', packageInfo);

  return (
    <ModalProvider>
      <Container>
        <LogoHeader />
        <Content>
          <HeadingArea>
            <Heading>Track Package</Heading>
            <Description>
              Hello,
              <b>{packageInfo?.customerEmail}</b> your package delivery is being
              processed and will be delivered on the expected date.
            </Description>
          </HeadingArea>
          <PackageStatus>
            <p>Package Status:</p>
            <Status>{`${getPackageStatus(packageInfo?.status)}`}</Status>
          </PackageStatus>
          <ButtonArea>
            <ReportIssueBtn />
          </ButtonArea>
          <LowerSection>
            <PackageStatusGraph
              status={getPackageStatus(packageInfo?.status)}
            />
          </LowerSection>
        </Content>
        <Modal>
          <ReportIssueModal />
        </Modal>
      </Container>
    </ModalProvider>
  );
};

export default TrackPackage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  margin: 2rem auto 8rem auto;
  justify-content: center;
  align-items: center;
`;

const HeadingArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (max-width: 480px) {
    width: 90vw;
  }
`;

const Heading = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  color: black;
`;

const Description = styled.p`
  font-size: 1.25rem;
  font-weight: 400;
  width: 40rem;

  @media (max-width: 480px) {
    font-size: 1rem;
    width: fit-content;
  }
`;

const PackageStatus = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  height: fit-content;
  font-size: 1rem;
  border-radius: 0.25rem;
  border: 1px solid ${({ theme }) => theme.palette.borderColor2};
  color: ${({ theme }) => theme.palette.text4};
`;

const Status = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primaryShades5};
`;

const ButtonArea = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;

  grid-row: 4;
  flex-direction: row;
  margin-top: 4rem;

  & > * {
    width: fit-content;
  }
`;

const LowerSection = styled.div`
  grid-template-columns: 1fr;
  grid-column: 1;

  border: none;
  margin-top: 0;
`;
